import { render, staticRenderFns } from "./yc-quota.vue?vue&type=template&id=38679788&scoped=true&"
import script from "./yc-quota.vue?vue&type=script&lang=js&"
export * from "./yc-quota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38679788",
  null
  
)

export default component.exports